<div class="uk-flex uk-flex-nowrap">
  <div class="text fullwidth pointer" (click)="showAll()">
    <p class="font-14 purple"><b>Addresses</b></p>
    <p class="font-13">{{ list.length }} item</p>
  </div>
  <div class="button-container uk-flex uk-flex-middle">
    <div class="inline-block float-right add-button" (click)="addModal()">
      <i class="fas fa-plus"></i>
    </div>
  </div>
</div>
<ul class="box-list-sidebar">
  <li
    *ngFor="let listItem of list | slice: 0:length; let i = index"
    (click)="edit(listItem)"
  >
    <div class="uk-flex uk-flex-nowrap">
      <div class="box-text">
        <p class="purple font-13">
          <b>{{ listItem.address_1 }}</b>
        </p>
        <p class="font-12 grey">{{ listItem.city }}</p>
      </div>
    </div>
  </li>
</ul>
